import forOwn from 'mout/object/forOwn'

export default function getFirstSubtestId(userAssessment) {
  let firstSubtest = ''
  if (userAssessment && userAssessment.assessmentSet) {
    if (userAssessment.assessmentSet.content) {
      forOwn(userAssessment.assessmentSet.content, (subtest, subtestId, content) => {
        if (!firstSubtest && subtest.active && subtest.index > -1) {
          firstSubtest = subtestId
        } else if (firstSubtest && subtest.active && subtest.index > -1 && subtest.index < content[firstSubtest].index) {
          firstSubtest = subtestId
        }
      })
    }
  } 
  return firstSubtest
}


// WEBPACK FOOTER //
// ./src/helpers/nav/getFirstSubtestId.js